import React from 'react'
import PropTypes from 'prop-types'
import { Tab } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import STATICS from '../../event.statics'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const AssetStatusFiltering = ({
  allAssets,
  availableAssets,
  postponedAssets,
  cancelledAssets,
  fetchAssets,
  data,
  assetsLoading,
  elmId,
  className,
}) => {
  const statusFilterAction = selectedTab => {
    const params = {
      available: null,
      status: null,
    }
    switch (selectedTab) {
      case 'available':
        params.available = 'Y'
        break
      case 'postponed':
        params.status = 'Postponed'
        break
      case 'cancelled':
        params.status = 'Cancelled'
        break
    }
    fetchAssets(params)
  }

  const onTabChange = (_, tabData) => {
    const selectedTabId = tabData.panes[tabData.activeIndex].tabId
    statusFilterAction(selectedTabId)
  }

  let selectedTab = 'all'
  data.available && (selectedTab = 'available')
  data.status && (selectedTab = data.status.toLowerCase())

  const statusTabs = [
    {
      tabId: 'all',
      menuItem:
        STATICS.ALL_ASSETS + (selectedTab === 'all' ? ` (${allAssets})` : ''),
      selected: selectedTab === 'all',
      displayTab: true,
    },
    {
      tabId: 'available',
      menuItem: `${STATICS.AVAILABLE_ASSETS} (${availableAssets})`,
      selected: selectedTab === 'available',
      displayTab: availableAssets > 0,
    },
    {
      tabId: 'postponed',
      menuItem: `${STATICS.POSTPONED_ASSETS} (${postponedAssets})`,
      selected: selectedTab === 'postponed',
      displayTab: postponedAssets > 0,
    },
    {
      tabId: 'cancelled',
      menuItem: `${STATICS.CANCELLED_ASSETS} (${cancelledAssets})`,
      selected: selectedTab === 'cancelled',
      displayTab: cancelledAssets > 0,
    },
  ].filter(tab => tab.displayTab)

  const selectedTabId =
    statusTabs.length > 1
      ? statusTabs.indexOf(statusTabs.find(tab => tab.selected))
      : 0

  if (assetsLoading || allAssets === 0) {
    return null
  }

  return (
    <div className={cx('status-filtering-menu-container', className)}>
      <Tab
        elmId={`asset_status_filtering_menu_${elmId}`}
        panes={statusTabs}
        onTabChange={onTabChange}
        activeIndex={selectedTabId}
      />
    </div>
  )
}

AssetStatusFiltering.propTypes = {
  allAssets: PropTypes.number.isRequired,
  availableAssets: PropTypes.number.isRequired,
  postponedAssets: PropTypes.number.isRequired,
  cancelledAssets: PropTypes.number.isRequired,
  fetchAssets: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  assetsLoading: PropTypes.bool.isRequired,
  elmId: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default AssetStatusFiltering
